import { AlarmLifetimeThresholdEnum } from './alarm-lifetime-threshold.enum';

export class CommonGlobals {
	static alarmLifetimeThreshold: AlarmLifetimeThresholdEnum;
}
